module.exports = __webpack_public_path__ + "static/img/leverageEU_2014_2020_rgb.461c104.png";